import { ReflectUtils } from "@dooboostore/core";
import { ValidUtils } from "@dooboostore/core";
var Lifecycle = /* @__PURE__ */ ((Lifecycle2) => {
  Lifecycle2["Singleton"] = "Singleton";
  Lifecycle2["Transient"] = "Transient";
  return Lifecycle2;
})(Lifecycle || {});
const sims = /* @__PURE__ */ new Map();
const containers = /* @__PURE__ */ new Set();
const SimMetadataKey = Symbol.for("simple-boot:sim-metadata");
const isNotNullObjetInstance = (target) => target != null && target !== void 0 && typeof target === "object";
const simProcess = (config, inputTarget) => {
  const target = (() => {
    if (typeof inputTarget === "object") {
      return config.scope === "Singleton" /* Singleton */ ? inputTarget : ValidUtils.isPlainObject(inputTarget) ? { ...inputTarget } : inputTarget;
    }
    if (ValidUtils.isArrowFunction(inputTarget)) {
      return () => inputTarget();
    }
    return inputTarget;
  })();
  let targetType;
  if (isNotNullObjetInstance(target)) {
    targetType = target.constructor;
  } else {
    targetType = target;
  }
  config.scope = config?.scope ?? "Singleton" /* Singleton */;
  ReflectUtils.defineMetadata(SimMetadataKey, config, targetType);
  const adding = (targetKey, target2 = targetKey) => {
    const items = sims.get(targetKey) ?? /* @__PURE__ */ new Set();
    items.add(target2);
    sims.set(targetKey, items);
  };
  if (Array.isArray(config?.type)) {
    config?.type.forEach((it) => {
      adding(it, target);
    });
  } else if (config.type) {
    adding(config?.type, target);
  } else {
    adding(target);
  }
};
function Sim(configOrTarget) {
  if (typeof configOrTarget === "symbol") {
    return (target) => {
      simProcess({ symbol: configOrTarget }, target);
    };
  } else if (typeof configOrTarget === "function") {
    simProcess({}, configOrTarget);
  } else {
    return (target) => {
      simProcess(configOrTarget, target);
    };
  }
}
const sim = Sim;
const injectable = Sim;
const getSim = (target) => {
  if (target != null && target !== void 0 && typeof target === "object") {
    target = Object.getPrototypeOf(target).constructor;
  }
  try {
    return ReflectUtils.getMetadata(SimMetadataKey, target);
  } catch (e) {
  }
};
const PostConstructMetadataKey = Symbol.for("simple-boot:post-construct-metadata");
const postConstructProcess = (target, config) => {
  const metas = getPostConstructs(target) ?? [];
  metas.push(config);
  ReflectUtils.defineMetadata(PostConstructMetadataKey, metas, target);
};
const PostConstruct = (target, propertyKey, descriptor) => {
  postConstructProcess(target, { property: propertyKey });
};
const getPostConstructs = (target) => {
  return ReflectUtils.getMetadata(PostConstructMetadataKey, target) ?? [];
};
const postConstruct = PostConstruct;
export {
  Lifecycle,
  PostConstruct,
  Sim,
  SimMetadataKey,
  containers,
  getPostConstructs,
  getSim,
  injectable,
  postConstruct,
  sim,
  simProcess,
  sims
};
//# sourceMappingURL=SimDecorator.js.map
